export const REDUCER_NAME = 'AUTH'

